import { FC } from 'react';

import CardDetailsHeader from 'features/Work/components/CardDetailsHeader';
import { CardDetailsHeaderOptions } from 'features/Work/components/CardDetailsHeader/types';
import { useInvoiceModals } from 'features/Work/pages/Invoices/hooks/useInvoiceModals';

import { Invoice } from '../../../../../../hooks/queries/useGetInvoice';
import locales from './locales';

interface DetailHeaderProps {
  invoice: Invoice;
}

const DetailHeader: FC<DetailHeaderProps> = ({ invoice }) => {
  const { openModal } = useInvoiceModals();
  const { status } = invoice;

  const canEditStatus = ['SENT', 'OVERDUE'].includes(status);

  const menuOptions: CardDetailsHeaderOptions[] = [
    {
      icon: 'tick',
      label: locales.invoicePaidTitle,
      onClick: () => openModal({ name: 'mark-as-paid', props: invoice }),
    },
    {
      description: locales.invoiceDuplicateAndCancelDescription,
      icon: 'edit',
      label: locales.invoiceDuplicateAndCancelTitle,
      onClick: () => openModal({ name: 'revise', props: invoice }),
    },
    {
      description: locales.invoiceCancelDescription,
      icon: 'cross',
      label: locales.invoiceCancelTitle,
      onClick: () => openModal({ name: 'cancel', props: invoice }),
    },
  ];

  return (
    <CardDetailsHeader
      canEditStatus={canEditStatus}
      item={invoice}
      options={menuOptions}
    />
  );
};

export default DetailHeader;
